export default __webpack_public_path__ + "static/media/xp-bed-b.9ae6a124.svg";